
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_7vjum_5",
  "inline-container": "awsui_inline-container_5a145_7vjum_9",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_7vjum_12",
  "inline-container-no-wrap": "awsui_inline-container-no-wrap_5a145_7vjum_15",
  "text-to-display": "awsui_text-to-display_5a145_7vjum_24"
};
  